import * as types from './types'
export default {
  [types.CANCEL_NEWRECOMMENDATION](state) {
    state.recommendations = state.recommendations.filter((item) => item.id !== 0)
  },
  [types.SET_RECOMMENDATIONACTIVATION](state, data) {
    for (const item of state.recommendations) {
      if (item.id === data.id) {
        item.isChanged = true
        break
      }
    }
  },
  [types.ADD_RECOMMENDATION](state, recommendation) {
    var cnt = 0
    for (const item of state.recommendations) {
      if (item.id === 0) {
        cnt++
      }
    }
    if (cnt === 0) {
      state.recommendations.unshift(recommendation)
    }
  },
  [types.SET_RECOMMENDATIONS](state, data) {
    state.recommendations = []
    if (
      data !== undefined &&
      data !== null
    ) {
      if (data !== '') {
        state.recommendations = data
        for (const item of state.recommendations) {
          item.isChanged = false
        }
      }
    }
  },
  [types.SET_RECOMMENDATION](state, data) {
    for (const item of state.recommendations) {
      if (item.id === data.id) {
        switch (data.name) {
        case 'IsInactive':
          item.isInactive = data.value
          break
        case 'Nickname':
          item.nickname = data.value
          break
        case 'VehicleMake':
          item.vehicleMake = data.value
          break
        case 'VehicleMakeName':
          item.vehicleMakeName = parseInt(data.value)
          break
        case 'Recommendation':
          item.recommendation = data.value
          break
        }
        item.isChanged = true
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/calibrate/mutations.js